import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["text"]
  static values = {
    speed: Number,
    delay: Number,
    key: String  // Optional key to track animation uniquely
  }

  // Clear all typing effect session storage (call before switching modes)
  static clearAll() {
    const keysToRemove = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith("typing_effect_played_")) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key))
  }

  // Action that can be called from buttons to reset typing effects
  reset() {
    this.constructor.clearAll()
  }

  connect() {
    // If no text target, this controller is just for the reset action
    if (!this.hasTextTarget) return

    const speed = this.hasSpeedValue ? this.speedValue : 80
    const delay = this.hasDelayValue ? this.delayValue : 500

    this.originalText = this.textTarget.textContent.trim()

    // Generate a storage key based on the text content or provided key
    const storageKey = this.hasKeyValue
      ? `typing_effect_played_${this.keyValue}`
      : `typing_effect_played_${this.originalText.substring(0, 30).replace(/\s+/g, '_')}`

    // Check if animation has already played in this session
    if (sessionStorage.getItem(storageKey)) {
      // Skip animation, just show the text
      this.textTarget.style.visibility = "visible"
      return
    }

    // Clear content and set up for typing
    this.textTarget.textContent = ""
    this.textTarget.style.visibility = "visible"

    // Create a text node to hold the typed text
    this.textNode = document.createTextNode("")
    this.textTarget.appendChild(this.textNode)

    // Add blinking dot cursor (matches chat streaming cursor)
    this.cursor = document.createElement("span")
    this.cursor.className = "streaming-cursor"
    this.textTarget.appendChild(this.cursor)

    // Store the key so we can mark completion
    this.storageKey = storageKey

    setTimeout(() => {
      this.typeText(0, speed)
    }, delay)
  }

  typeText(index, speed) {
    if (index < this.originalText.length) {
      // Append character to the text node (preserves cursor element)
      this.textNode.textContent += this.originalText.charAt(index)
      setTimeout(() => {
        this.typeText(index + 1, speed)
      }, speed)
    } else {
      // Mark animation as played
      if (this.storageKey) {
        sessionStorage.setItem(this.storageKey, "true")
      }
      // Remove cursor after typing is done
      setTimeout(() => {
        if (this.cursor) {
          this.cursor.remove()
        }
      }, 1500)
    }
  }
}
